<template>
    <div class="file-detail-subtab customer-subtab">
        <div class="file-detail-btn" v-show="isOutsideChannel">
            <lots-button type="text" icon="el-icon-circle-plus-outline" size="medium" v-has="authorityCode.contactAdd"
                @click="handleAddRow()">新增</lots-button>
            <lots-button type="text" icon="el-icon-circle-check" size="medium" :loading="saveLoading"
                v-has="authorityCode.contactSave" @click="handleSaveRows">保存</lots-button>
            <lots-button type="text" icon="el-icon-delete" size="medium" @click="handleDeleteRows()"
                v-has="authorityCode.contactDel">删除</lots-button>
        </div>
        <edit-table-box class="prescreen" v-loading="subTabTable.tableLoading" ref="editTableBox"
            @selection-change="handleSelectedRow" :selection="config.selection" :control="false"
            :columns="TABLECONFIG.columns" :height="tableHeight" :tableData="subTabTable.totalData"
            @action-click="actionClick">
            <template #col-header="{ item }">
                <span class="slot-box" v-if="['mobile', 'email', 'fax', 'contactAddress', 'tel'].includes(item.prop)">
                    <span>
                        {{ item.label }}
                    </span>
                    <img :class="['text-eyes', item.className]" @click="handleChangeText(item)"
                        :src="encryption[item.prop] ? iconOpenEyes : iconCloseEyes" alt="">
                </span>
                <span v-else> {{ item.label }}</span>
            </template>
            <template v-slot:col-append="{ item, row, rIndex }">
                <div v-if="['mobile', 'email', 'fax', 'contactAddress', 'tel'].includes(item.prop)">
                    <span size="mini" type="text" class="mip-page-link no-wrap" :title="row[item.prop]">{{
                        encryptionHandle(row[item.prop] || '', item.prop)
                    }}</span>

                </div>
            </template>
        </edit-table-box>

        <div class="footer"> </div>
    </div>
</template>

<script>
// import lotsPagination from '@/components/lots/lotsPagination/Index';
import { AdvanceListClass } from '@/modules/mdm/composition/dc/common/list/AdvanceListClass';
import { ref, watch, computed, reactive } from '@vue/composition-api';
import { tableConfig } from './config.js';
import lotsButton from '@/components/lots/lotsButton';
import editTableBox from '@/components/lots/editTableBox/Index';
import { saveContactInfo, queryContactInfoByCustomerCode, deleteContactInfo } from '@/modules/mdm/api/customer/customerManage.js';
import iconOpenEyes from '@/assets/images/icon-open-eyes.png';
import iconCloseEyes from '@/assets/images/icon-close-eyes.png';
import _ from 'lodash';
import { Message } from 'element-ui';
import btnAuthority from '@/modules/mdm/btnAuthority.js';

import otherUtils from '@/modules/mdm/utils/otherCommonFunc.js';
export default {
    components: {
        editTableBox, lotsButton
    },
    props: {
        activeName: {
            type: String,
            default: () => ''
        },
        detailData: {
            type: Object,
            return: () => { }
        },
        tableHeight: {
            type: Number,
            default: 357
        },
        actions: { // 表格操作信息，不传默认为空
            type: Object,
            default() {
                return {
                    list: []
                };
            }
        }
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const config = reactive(tableConfig);
        const authorityCode = reactive(btnAuthority.customerManage);
        // eslint-disable-next-line complexity
        const TABLECONFIG = computed(() => {
            return config;
        });
        const isOutsideChannel = computed(() => {
            if (!props.detailData.ebcuId) return false; // 新增不可编辑
            return props.detailData.customerChannel !== '2';
        });
        const convertEmptyStringsToNull = (obj) => {
            return _.mapValues(obj, value => {
                if (typeof value === 'string') {
                    return _.trim(value) === '' ? null : value;
                }
                return value;
            });
        };
        const oldTotalData = ref([]);
        class IhistoryTalbeClass extends AdvanceListClass {
            beforeGetList(condition) {
                condition.customerCode = props.detailData.customerCode;
                condition.orderBy = orderBy.value;
                condition.orderByType = orderByType.value;
                condition = convertEmptyStringsToNull(condition);
                return condition;
            }
            afterGetList(res) {
                if (+res.code === 0 && res.data) {
                    oldTotalData.value = _.cloneDeep(res.data.map(it => {
                        it.customerName = props.detailData.customerName;
                        return it;
                    }) || []);
                    subTabTable.totalData.value = res.data.map(it => {
                        it.customerName = props.detailData.customerName;
                        it.isDefault = it.isDefault?.toString();
                        return it;
                    });
                    setupContext.root.$nextTick(() => {
                        setupContext.refs.editTableBox && setupContext.refs.editTableBox.$refs.moduleTable.doLayout();
                    });
                }
                // super.afterGetList(res);
            }
        };
        const subTabTable = new IhistoryTalbeClass({
            Api: {
                listApi: queryContactInfoByCustomerCode
            }

        });
        watch(
            () => [props.activeName, props.detailData],
            async (newVal, oldVal) => {
                if (newVal[0] === 'contact' && newVal[1].customerCode) {
                    subTabTable.getList();
                }
            }
        );

        const orderBy = ref('create_time');
        const orderByType = ref('desc');

        const actionClick = (event, row) => {

        };
        const handleAddRow = () => {
            // refs.editTableBox.addRow();
            const newItem = {
                edit: 2,
                customerCode: props.detailData.customerCode,
                customerName: props.detailData.customerName
            };
            subTabTable.totalData.value.unshift(newItem);
            setupContext.refs.editTableBox.$refs.moduleTable.toggleRowSelection(newItem, true);
        };
        const selectedRows = ref([]); // 选中的行数组
        const handleSelectedRow = (selection) => {
            selectedRows.value = selection;
        };
        const saveLoading = ref(false);
        const handleSaveRows = async (type) => {
            if (!selectedRows.value.length) {
                return Message.warning('请选择数据进行保存！');
            }
            try {
                selectedRows.value.forEach(v => {
                    if (setupContext.refs.editTableBox.saveItemData(v) === false) {
                        throw Error();
                    }
                });
            } catch (err) { return; }
            const params = selectedRows.value.map(item => {
                const newItem = _.omit(item, ['edit', 'backup', 'sealAdminDict', 'serialNum']);
                return {
                    ...newItem
                };
            });
            // const res = '';
            saveLoading.value = true;
            try {
                const res = await saveContactInfo(params);
                if (res && +res.code === 0) {
                    Message({
                        message: '保存成功',
                        type: 'success'
                    });
                    subTabTable.getList({
                        customerCode: props.detailData.customerCode
                    }); // 刷新列表
                }
                saveLoading.value = false;
            } catch (error) {
                saveLoading.value = false;
            }
        };
        const handleDeleteRows = async () => { // 调批量删除接口
            if (selectedRows.value.length === 0) {
                Message.error('请选择需要删除的条目');
                return;
            }
            let passFlag = true;
            selectedRows.value.forEach(item => {
                if (!item.id) {
                    passFlag = false;
                }
            });
            if (!passFlag) {
                return Message.warning('存在新增未保存的数据，请先保存或取消编辑');
            }
            const id = JSON.parse(JSON.stringify(selectedRows.value)).map((v) => v.id);
            const params = {
                id,
                customerCode: props.detailData.customerCode
            };
            deleteContactInfo(params).then(res => {
                if (res && +res.code === 0) {
                    Message.success('删除成功!');
                    subTabTable.getList();
                }
            });
        };
        const encryption = ref({
            mobile: false,
            tel: false,
            contactAddress: false,
            fax: false,
            email: false
        });
        const handleChangeText = (item) => {
            encryption.value[item.prop] = !encryption.value[item.prop];
        };
        // 对应加密方法
        const menuList = {
            mobile: 'mobile',
            tel: 'phone',
            email: 'email',
            fax: 'fax',
            contactAddress: 'address'
        };
        const encryptionHandle = (val, p) => {
            const { desensitization } = otherUtils;
            const prop = menuList[p];
            if (!desensitization[prop]) return '';
            if (encryption.value[p]) return val;
            return desensitization[prop](val);
        };
        return {
            config,
            TABLECONFIG,
            subTabTable,
            isOutsideChannel,
            saveLoading,
            iconCloseEyes,
            iconOpenEyes,
            encryption,
            authorityCode,
            encryptionHandle,
            handleChangeText,
            handleSelectedRow,
            actionClick,
            handleAddRow,
            handleSaveRows,
            handleDeleteRows
        };
    }
};
</script>
<style lang='less' scoped>
.text-eyes {
    width: 14px;
    margin-left: 4px;
    cursor: pointer;
    position: relative;
    top: 2px;
}

.contract-manage-iflow-table {
    .file-detail-btn {
        width: 100%;
        display: flex;
        align-items: center;

        .sub-tab-search-box {
            flex: 1;
            height: 28px;
            margin: 0 0 0 30px;

            .search-box {
                &>div>button.search-btn {
                    height: 24px;
                    min-height: 24px;
                    padding: 2px 4px;
                    margin-top: 2px;
                    /* background-color: #4285F5;
                        border-color: #4285F5; */
                }

                .search {

                    .el-input-group__append,
                    .el-input-group__prepend {
                        padding: 0 14px;
                    }
                }
            }
        }
    }

    // margin-top: 15px;
    .footer {
        padding: 10px 0;
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }

    .mip-page-link {
        color: #4285f5;
        cursor: pointer;

        &.no-wrap {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }

    .price-icon {
        font-size: 12px;
        cursor: pointer;
        color: #000;
    }

    .icon-active {
        color: #4285f5 !important;
    }
}
</style>
